import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from "../../../environments/environment";
import { InspectionService } from "../shared/services/inspection.service";
import { Inspection, InspectionStatuses, InspectionTypes as ITPS} from "./../shared/models/Inspection";
import * as Constants from "../../models/Constants";
import { ErisFormComponent } from "eris-forms";
import { AlertService } from "../../shared/services/alert.service";
import { ErrorHandlerService } from "../../services/error-handler.service";

@Component({
  selector: "app-create-local-gmp-inspection",
  templateUrl: "./create-local-gmp-inspection.component.html",
  styleUrls: ["./create-local-gmp-inspection.component.css"],
})
export class CreateLocalGmpInspectionComponent implements OnInit , AfterViewInit{

  @ViewChild(ErisFormComponent) erisFormComponent!: ErisFormComponent;
  public currentInspectionType: string;
  public currentInspectionName: string;
  public productionSubTypeModule: any;
  public previousInspectionId: any;
  public approvalMethod: string = Constants.CATEGORY_B;
  public options: FormlyFormOptions = {};
  public form = new FormGroup({});
  public isEditMode = false;
  public inspection: Inspection;
  public categoryId : number = 0;
  public agencyId : number = 0;
  public applicantTypeId : number = 0;
  public isFIREditing : boolean = false;

  constructor(private inspectionService: InspectionService, private spinner: NgxSpinnerService, private router: Router,
    private activatedRoute: ActivatedRoute, private cdr: ChangeDetectorRef, private alertService: AlertService,
    private errorHandlerService: ErrorHandlerService) {
    this.currentInspectionType = this.activatedRoute.snapshot.params[
      "inspectionTypeCode"
    ];

    this.activatedRoute.params.subscribe((params) => {
      const inspectionTypeCode = params["inspectionTypeCode"];
      this.currentInspectionName = ITPS.codeToName(inspectionTypeCode);
      this.currentInspectionType = inspectionTypeCode;
    });
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() : void{
    const id = this.activatedRoute.snapshot.params['id'];
    if(id){
      this.isEditMode = true;
      this.fetchInspectionData(id);
    }
  }

  fiels = [
    {
      type: "steps",
      fieldGroup: [
        {
          key: "facilities",
          fieldGroupClassName: "row",
          templateOptions: { title: "Facilities" },
          fieldGroup: [
            {
              fieldGroupClassName: "row",
              templateOptions: { title: "Facilities" },
              fieldGroup: [
                {
                  key: "facility",
                  type: "lookup",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Facilities",
                    required: true,
                    multiple: false,
                    prefetch: true,
                    searchable: false,
                    minLengthTerm: 0,
                    disabled: false,
                    responseFn: (res) => ({
                      name: res.name,
                      id: res.id,
                      inspectionID: res.inspectionID,
                      isLegacyData: res.isLegacyData,
                      inspectionStatusCode: res.inspectionStatusCode,
                    }),
                    list: {
                      method: "get",
                      url: (term) =>
                        `${environment.baseUrl}/Inspection/LocalGMPInspection/New/GetFacilities`,
                      responseFn: (res) => {
                        res?.forEach(element => {
                          element.name = element.name + " (" + element.applicationID + element.applicationNumber + ") "
                        });
                        return res;
                      }
                    },
                  },
                  validators: {
                    validation: ["legacy"],
                  },
                  expressionProperties: {
                    "className": () => {
                      return this.isEditMode ? "col-md-6 disabled" : "col-md-6";
                    },
                  }
                },
                {
                  type: 'edit-anchor',
                  key: 'editApplication',
                  className: "col-md-6",
                  templateOptions: {
                    inspectionType: 'NLGI'
                  },
                  hideExpression: (
                    model: any,
                    formState: any,
                    field: FormlyFieldConfig
                  ) => {
                    return model.facility?.isLegacyData && model.facility?.inspectionStatusCode != InspectionStatuses.LEGACY_DATA_EDITED ? false: true;
                  },
                },
              ],
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            return this.isFIREditing;
          },
        },
        {
          key: "productionInformation",
          fieldGroupClassName: "row",
          templateOptions: { title: "Production Information" },
          fieldGroup: [
            {
              key: "productDetailData",
              type: "gmp-product-detail",
              className: "col-md-12",
              templateOptions: {
                isDisabled: false,
                editing: false
              },
              expressionProperties: {
                "templateOptions.editing": () => {
                  return this.isEditMode;
                },
              }
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            return this.isFIREditing;
          },
        },
        {
          key: "fileAttachment",
          templateOptions: {
            title: "File Attachment",
            description: "",
            icon: "fa fa-info-circle",
          },
          fieldGroup: [
            {
              key: "documents",
              type: "upload-list",

              templateOptions: {
                label: "Applicant Name",
                required: true,
                items: [],
                dependsOnField: "facilities.facility",
                dataSourceFn: (submoduleCode) => {
                  return {
                    url: `/DocumentRef/GMP/${submoduleCode}`,
                  };
                },
                extraData: {
                  urlParameter: "",
                  originalFileName: "-",
                  editing: false,
                  categoryTypeID: "",
                  AgencyTypeID: "",
                  ApplicantTypeID: "",
                },
                responseFn: (res) => res,
              },
              expressionProperties: {
                "templateOptions.extraData.urlParameter": (
                  model,
                  formState,
                  field
                ) => {
                  return this.currentInspectionType;
                },
                "templateOptions.extraData.editing": () => {
                  return this.isEditMode;
                },
                "templateOptions.extraData.categoryTypeID": () => {
                  return this.categoryId;
                },
                "templateOptions.extraData.AgencyTypeID": () => {
                  return this.agencyId;
                },
                "templateOptions.extraData.ApplicantTypeID": () => {
                  return this.applicantTypeId;
                },
              },
            },
          ],
        },
      ],
    },
  ];


  fields = [
    {
      type: "steps",
      fieldGroup: [
        {
          key: "facilities",
          fieldGroupClassName: "row",
          templateOptions: { title: "Facilities" },
          fieldGroup: [
            {
              fieldGroupClassName: "row",
              templateOptions: { title: "Facilities" },
              fieldGroup: [
                {
                  key: "facility",
                  type: "lookup",
                  className: "col-md-6",
                  templateOptions: {
                    label: "Facilities",
                    required: true,
                    multiple: false,
                    prefetch: true,
                    searchable: false,
                    minLengthTerm: 0,
                    responseFn: (res) => {
                      if(res.inspectionID){
                        this.previousInspectionId = res.inspectionID;
                        this.fetchInspectionData(this.previousInspectionId);
                      }            
                      return {
                        name: res.name,
                        id: res.id,
                        inspectionID: res.inspectionID,
                        isLegacyData: res.isLegacyData,
                        inspectionStatusCode: res.inspectionStatusCode,
                      }
                    },
                    list: {
                      method: "get",
                      url: (term) =>
                        `${environment.baseUrl}/Inspection/LocalGMPInspection/Renewal/GetFacilities`,
                      responseFn: (res) => {
                        res?.forEach(element => {
                          element.name = element.name + " (" + element.applicationID + element.applicationNumber + ") "
                        });
                        return res;
                      },
                    },
                  },
                  validators: {
                    validation: ["legacy"],
                  },
                  expressionProperties: {
                    "className": () => {
                      return this.isEditMode ? "col-md-6 disabled" : "col-md-6";
                    },
                  },
                },
                {
                  type: 'edit-anchor',
                  key: 'editApplication',
                  className: "col-md-6",
                  templateOptions: {
                    inspectionType: 'LGRI'
                  },
                  hideExpression: (
                    model: any,
                    formState: any,
                    field: FormlyFieldConfig
                  ) => {
                    return model.facility?.isLegacyData && model.facility?.inspectionStatusCode != InspectionStatuses.LEGACY_DATA_EDITED ? false: true;
                  },
                },
              ],
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            return this.isFIREditing;
          },
        },
        {
          key: "productionInformation",
          fieldGroupClassName: "row",
          templateOptions: { title: "Production Information" },
          fieldGroup: [
            {
              key: "productDetailData",
              type: "gmp-product-detail",
              className: "col-md-12",
              templateOptions: {
                isDisabled: false,
                editing: false,
                isDataFilled: true
              },
              expressionProperties: {
                "templateOptions.editing": () => {
                  return this.isEditMode;
                },
              }
            },
          ],
          hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
            return this.isFIREditing;
          },
        },
        {
          key: "fileAttachment",
          templateOptions: {
            title: "File Attachment",
            description: "",
            icon: "fa fa-info-circle",
          },
          fieldGroup: [
            {
              key: "documents",
              type: "upload-list",

              templateOptions: {
                label: "Applicant Name",
                required: true,
                items: [],
                dependsOnField: "facilities.facility",
                dataSourceFn: (submoduleCode) => {
                  return {
                    url: `/DocumentRef/GMP/${submoduleCode}`,
                  };
                },
                extraData: {
                  urlParameter: "",
                  originalFileName: "-",
                  editing: false,
                  categoryTypeID: "",
                  AgencyTypeID: "",
                  ApplicantTypeID: "",
                },
                responseFn: (res) => res,
              },
              expressionProperties: {
                "templateOptions.extraData.urlParameter": (
                  model,
                  formState,
                  field
                ) => {
                  return this.currentInspectionType;
                },
                "templateOptions.extraData.editing": () => {
                  return this.isEditMode;
                },
                "templateOptions.extraData.categoryTypeID": () => {
                  return this.categoryId;
                },
                "templateOptions.extraData.AgencyTypeID": () => {
                  return this.agencyId;
                },
                "templateOptions.extraData.ApplicantTypeID": () => {
                  return this.applicantTypeId;
                },
              },
            },
          ],
        },
      ],
    },
  ];

  onSubmit(event) {
    this.spinner.show();
    var link = "New";
    if (this.currentInspectionType == "LGRI") {
      event.previousInspectionId = this.previousInspectionId;
      link = "Renewal";
    }

    if(this.isFIREditing) {
      this.inspectionService.submitFurtherInformation(this.inspection.id, event.fileAttachment).subscribe(res => {
        this.spinner.hide();
        if (res) {
          this.alertService.success("Your Application was submitted successfully");
          this.router.navigate(["inspections/localGMP/list/LOCALGMP"]);
        } else {
          this.alertService.error("Unable to submit your Application, please try again!");
        }
      }, error => {
        console.log(error);
        this.spinner.hide();
        this.alertService.error(this.errorHandlerService.handleApiError(error));
      });    
    } else {
      event.productionInformation["productDetails"] = event.productionInformation.productDetailData?.productDetails;

      if(!this.isEditMode){
        this.inspectionService.postLocalGMPForm(event, link).subscribe(data => {
          this.spinner.hide();
          if (data) {
            this.alertService.success("Your Application was submitted successfully");
            this.router.navigate(["inspections/localGMP/list/LOCALGMP"]);
          } else {
            this.alertService.error("Unable to submit your Application, please try again!");
          }
        }, error => {
          console.log(error);
          this.spinner.hide();
          this.alertService.error(this.errorHandlerService.handleApiError(error));
        });
      } else {
        event.inspectionId = this.inspection.id;
        event.previousInspectionId = this.currentInspectionType == "LGRI" ? this.inspection.previousInspectionID : 0;
        this.inspectionService.editLocalGMPForm(event, link).subscribe(data => {
          this.spinner.hide();
          if(data){
            this.alertService.success("Your Application was edited successfully");
            this.router.navigate(["inspections/localGMP/list/LOCALGMP"]);
          } else {
            this.alertService.error("Unable to edit your Application, please try again!");
          }
        }, error => {
          console.log(error);
          this.spinner.hide();
          this.alertService.error(this.errorHandlerService.handleApiError(error));
        });
      }  
    }

  }

  fetchInspectionData(inspectionId){
    this.spinner.show();
    this.inspectionService.getInspection(inspectionId).subscribe(data => {
      this.isFIREditing =  [InspectionStatuses.FIR_REQUESTED_BEFORE_INSPECTION, 
        InspectionStatuses.FIR_REQUESTED_AFTER_INSPECTION].includes(data.status.inspectionStatusCode);

      let newProductionInformation = {
        productDetailData: {
          productDetails: data.productionInfo.productDetails
        }
      };

      if(!this.isEditMode){
        var tempModel = {
          facilities: this.erisFormComponent.form.value.facilities,
          productionInformation: newProductionInformation,
          fileAttachment: this.erisFormComponent.form.value.fileAttachment
        };

        this.erisFormComponent.model = tempModel;
      } else {
        this.inspection = data;
        this.erisFormComponent.model = {
          facilities: { facility : {id: data.facilityInfo.facilityID, name: data.facilityInfo.name} },
          productionInformation: newProductionInformation,
          fileAttachment: {documents: data.documents}
        };
      }

      this.cdr.detectChanges();
      this.spinner.hide()
    }, err => {
      this.spinner.hide();
      if(this.isEditMode){
        this.alertService.error("The Inspection Couldn't be Retrieved for Editing!");
      } else {
        this.alertService.error("The Previous Inspection Couldn't be Retrieved!");
      }
    })
  }
}
